import React from 'react';
import { HashRouter, BrowserRouter } from 'react-router-dom';

interface RouterWrapperProps {
  basename: string;
  routeType: string;
  children: React.ReactNode;
}

const RouterWrapper: React.FunctionComponent<RouterWrapperProps> = props => {
  const { basename, routeType, children } = props;

  return (
    (routeType === 'hash' && <HashRouter basename={basename}>{children}</HashRouter>) || (
      <BrowserRouter basename={basename}>{children}</BrowserRouter>
    )
  );
};

export default RouterWrapper;
